import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=01aa0ea2&scoped=true&lang=pug&"
import script from "./FormLabel.vue?vue&type=script&lang=js&"
export * from "./FormLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=01aa0ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01aa0ea2",
  null
  
)

export default component.exports